module.exports = __webpack_public_path__ + "static/media/img1@2x.4dcb160e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity50/img1@2x.png
// module id = 1048
// module chunks = 0